var _excluded = ["attachments"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import Attachment from "./Attachment";
import PropType from "prop-types";
var Attachments = function Attachments(_ref) {
  var attachments = _ref.attachments,
    rest = _objectWithoutProperties(_ref, _excluded);
  return attachments.map(function (attachment) {
    return /*#__PURE__*/React.createElement(Attachment, Object.assign({
      key: attachment.id,
      attachment: attachment,
      allowDelete: (rest === null || rest === void 0 ? void 0 : rest.allowDelete) || false
    }, rest));
  });
};
Attachments.propType = {
  attachments: PropType.array
};
export default Attachments;